import { useUser } from '@clerk/clerk-react';
import { Info } from 'lucide-react';

export default function ReviewModeBanner() {
  const { user, isLoaded } = useUser();
  if (!isLoaded || !user) return null;
  if (user.publicMetadata?.review_account !== true) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="review-mode-banner"
      className="sticky top-0 z-40 bg-sky-100 dark:bg-sky-900/40 border-b border-sky-300 dark:border-sky-700 text-sky-900 dark:text-sky-100"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-2">
        <Info className="w-4 h-4 flex-shrink-0" strokeWidth={2.25} />
        <p className="text-caption font-medium">
          Demo mode — Media Station responses are simulated for review.
        </p>
      </div>
    </div>
  );
}
